import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { api } from "../lib/api";
import { useLang } from "../context/LanguageContext";

const Stars = () => (
  <div className="flex gap-1">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} size={13} className="fill-gold text-gold" />
    ))}
  </div>
);

const ReviewsWall = () => {
  const { t, lang } = useLang();
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    api.get("/reviews").then(({ data }) => setReviews(data)).catch(() => {});
  }, []);

  if (reviews.length === 0) return null;

  return (
    <section data-testid="reviews-wall" className="border-b border-engraved bg-white py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7 }}
          className="mx-auto max-w-2xl text-center"
        >
          <p className="eyebrow">{t("rv.eyebrow")}</p>
          <h2 className="mt-4 font-serif text-3xl font-bold tracking-tight text-navy sm:text-4xl">
            {t("rv.heading")}
          </h2>
        </motion.div>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {reviews.map((r, i) => (
            <motion.figure
              key={r.id}
              data-testid={`review-card-${i}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ delay: (i % 3) * 0.1, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
              className="flex flex-col border border-engraved bg-paper p-8 shadow-elevated"
            >
              <Stars />
              <blockquote className="mt-5 flex-1 font-serif text-lg italic leading-relaxed text-navy">
                “{lang === "es" && r.text_es ? r.text_es : r.text_en}”
              </blockquote>
              <figcaption className="mt-6 border-t border-engraved pt-4">
                <p className="font-cinzel text-xs font-bold uppercase tracking-[0.2em] text-ink">{r.name}</p>
                <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">{r.area}</p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ReviewsWall;
